import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { tableCellMinWidth } from '@atlaskit/editor-common/styles';
import { akEditorTableNumberColumnWidth } from '@atlaskit/editor-shared-styles';
import { getTableWidth } from '../../../utils';
import { getLayoutSize } from '../utils/misc';
import { reduceSpace } from '../utils/resize-logic';
import { adjustColumnsWidths, getResizeState, getTotalWidth } from '../utils/resize-state';
// Base function to trigger the actual scale on a table node.
// Will only resize/scale if a table has been previously resized.
export var scale = function scale(tableRef, options, domAtPos) {
  /**
   * isBreakoutEnabled === true -> default center aligned
   * isBreakoutEnabled === false -> full width mode
   */

  var node = options.node,
    containerWidth = options.containerWidth,
    previousContainerWidth = options.previousContainerWidth,
    prevNode = options.prevNode,
    start = options.start,
    isBreakoutEnabled = options.isBreakoutEnabled,
    layoutChanged = options.layoutChanged;
  var maxSize = getLayoutSize(node.attrs.layout, containerWidth, {
    isBreakoutEnabled: isBreakoutEnabled
  });
  var prevTableWidth = getTableWidth(prevNode);
  var previousMaxSize = getLayoutSize(prevNode.attrs.layout, previousContainerWidth, {
    isBreakoutEnabled: isBreakoutEnabled
  });
  var newWidth = maxSize;

  // adjust table width if layout is updated
  var hasOverflow = prevTableWidth > previousMaxSize;
  if (layoutChanged && hasOverflow) {
    // No keep overflow if the old content can be in the new size
    var canFitInNewSize = prevTableWidth < maxSize;
    if (canFitInNewSize) {
      newWidth = maxSize;
    } else {
      // Keep the same scale.
      var overflowScale = prevTableWidth / previousMaxSize;
      newWidth = Math.floor(newWidth * overflowScale);
    }
  }
  if (node.attrs.isNumberColumnEnabled) {
    newWidth -= akEditorTableNumberColumnWidth;
  }
  var resizeState = getResizeState({
    minWidth: tableCellMinWidth,
    maxSize: maxSize,
    table: node,
    tableRef: tableRef,
    start: start,
    domAtPos: domAtPos
  });
  return scaleTableTo(resizeState, newWidth);
};
export var scaleWithParent = function scaleWithParent(tableRef, parentWidth, table, start, domAtPos) {
  var resizeState = getResizeState({
    minWidth: tableCellMinWidth,
    maxSize: parentWidth,
    table: table,
    tableRef: tableRef,
    start: start,
    domAtPos: domAtPos
  });
  if (table.attrs.isNumberColumnEnabled) {
    parentWidth -= akEditorTableNumberColumnWidth;
  }
  return scaleTableTo(resizeState, Math.floor(parentWidth));
};

// Scales the table to a given size and updates its colgroup DOM node
export function scaleTableTo(state, maxSize) {
  var scaleFactor = maxSize / getTotalWidth(state);
  var newState = _objectSpread(_objectSpread({}, state), {}, {
    maxSize: maxSize,
    cols: state.cols.map(function (col) {
      var minWidth = col.minWidth,
        width = col.width;
      var newColWidth = Math.floor(width * scaleFactor);
      if (newColWidth < minWidth) {
        newColWidth = minWidth;
      }
      return _objectSpread(_objectSpread({}, col), {}, {
        width: newColWidth
      });
    })
  });
  var newTotalWidth = getTotalWidth(newState);
  if (newTotalWidth > maxSize) {
    newState = reduceSpace(newState, newTotalWidth - maxSize);
  }
  return adjustColumnsWidths(newState, maxSize);
}